import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './SelectBuilding.scss';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken, randomNumber } from '../../common/_commonFunction';
import { Loading } from '../../components';
import { passParamsToPath, history, isSuperAdmin, isAccounting, isCashier } from '../../helpers';
import { 
  fetchGetBuilding, 
  fetchGetDraftBuilding,
  setBuildingInformation,
  setBuildingParkingFeeModelCar,
  setBuildingParkingFeeModelMotorcycle,
  setRedemptionModelInformation,
  setConfigCommon,
  setConfig,
  setBuildingContent,
  setBuildingTenant,
  setBuildingIotDevice,
  setBuildingParkingDayConfig, 
  setCurrentBuildingDataPath,
} from '../../actions';
import { NotFound } from '../../pages';

class SelectBuilding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': true,
      'activeTab': 'building',
    };
    if (!getCookieToken()) {
      history.push(commonConstant.pathLogout);
    } else if (isSuperAdmin(props.getProfile.data)) {
      props.dispatch(fetchGetBuilding());
      props.dispatch(fetchGetDraftBuilding());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getBuilding, getProfile } = this.props;

    if (nextProps.getBuilding && nextProps.getBuilding !== getBuilding) {
      return this.setState({ 'loading': false });
    } else if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      if (nextProps.getProfile.status === 200 && isSuperAdmin(nextProps.getProfile.data)) {
        this.setState({ 'loading': true });
        this.props.dispatch(fetchGetBuilding());
        this.props.dispatch(fetchGetDraftBuilding());
      }
    }
  }

  handleDraftBuildingRedirect = (draftBuildingId) => {    
    this.props.dispatch(setBuildingInformation(null));
    this.props.dispatch(setBuildingParkingFeeModelCar(null));
    this.props.dispatch(setBuildingParkingFeeModelMotorcycle(null));
    this.props.dispatch(setRedemptionModelInformation(null));
    this.props.dispatch(setConfigCommon(null));
    this.props.dispatch(setConfig(null));
    this.props.dispatch(setBuildingContent(null));
    this.props.dispatch(setBuildingTenant(null));
    this.props.dispatch(setBuildingIotDevice(null));
    this.props.dispatch(setBuildingParkingDayConfig(null));    

    history.push(passParamsToPath(commonConstant.pathEditDraftedBuilding, { 'draftedBuildingID': draftBuildingId }));
  }

  handleDraftBuilding = () => {
    const { getDraftBuilding } = this.props;

    if (!getDraftBuilding.data) {
      return null;
    }

    return getDraftBuilding.data.map((ele, index) => (
      <div
        id={`building-${index}`}
        className="box-item"
        key={randomNumber()}
        onClick={() => this.handleDraftBuildingRedirect(ele.draftedBuildingID)}
      >
        <div className="draft-building-info">
          <div
            className="draft-building-number"
            id={`building-ref-number-${index}`}
          >
            {ele.draftedBuildingRefNo}
          </div>
          <div
            className="draft-building-name"
            id={`building-name-${index}`}
          >
            {ele.importDataDraftedBuilding.building.buildingName}
          </div>
        </div>

      </div>
    ));
  }

  handleDraftBuildingSection = () => 
    <div className="draft-building-list">
      {this.handleDraftBuilding()}
    </div>

  handleRedirectBuilding = (data) => {
    this.props.dispatch(setCurrentBuildingDataPath({ 'buildingID': data.buildingID, 'buildingRefNo': data.buildingRefNo, 'buildingName' : data.buildingName }));
    history.push(passParamsToPath(commonConstant.pathAccountingReport, { 'buildingID': data.buildingID, 'buildingRefNo': data.buildingRefNo }));
  }

  handleBuilding = () => {
    const { getBuilding } = this.props;

    if (!getBuilding.data) {
      return null;
    }

    return getBuilding.data.map((ele, index) => (
      <div
        id={`building-${index}`}
        className="box-item"
        key={randomNumber()}
        onClick={() => this.handleRedirectBuilding(ele)}
      >
        <div className="building-logo-container" id={`building-logo-${index}`}>
          <img className="building-logo" alt="building-logo" src={ele.buildingLogoImage} />
        </div>
        <div className="building-info">
          <div
            className="building-number"
            id={`building-ref-number-${index}`}
          >
            {ele.buildingRefNo}
          </div>
          <div
            className="building-name"
            id={`building-name-${index}`}
          >
            {ele.buildingName}
          </div>
        </div>

      </div>
    ));
  }

  handleRedirectCreateBuilding = () => {
    this.props.dispatch(setBuildingInformation(null));
    this.props.dispatch(setBuildingParkingFeeModelCar(null));
    this.props.dispatch(setBuildingParkingFeeModelMotorcycle(null));
    this.props.dispatch(setRedemptionModelInformation(null));
    this.props.dispatch(setConfigCommon(null));
    this.props.dispatch(setConfig(null));
    this.props.dispatch(setBuildingContent(null));
    this.props.dispatch(setBuildingTenant(null));
    this.props.dispatch(setBuildingIotDevice(null));
    this.props.dispatch(setBuildingParkingDayConfig(null));    
    
    history.push(commonConstant.pathCreateBuilding);
  }

  handleBuildingSection = () =>
    <div className="building-section">
      <div className="button-container">
        <Button className="btn-primary" id="btn-create-building" onClick={() => this.handleRedirectCreateBuilding()}>
          <div className="create-building-button">
            <div className="icon icon-add" />
            <div className="text">สร้างตึกใหม่</div>
          </div>
        </Button>
      </div>
      <div className="building-list">
        {this.handleBuilding()}
      </div>
    </div>


  render() {
    const { getBuilding, getProfile, getDraftBuilding } = this.props;
    const { loading } = this.state;

    if (!getProfile.data) {
      return <Loading />;
    } else if (isAccounting(getProfile.data)) {
      return <Redirect to={passParamsToPath(commonConstant.pathAccountingReport, getProfile.data.building)} />;
    } else if (isCashier(getProfile.data)) {
      return (
        <div className="no-sidebar-layout">
          <NotFound />
        </div>
      );
    } else if (!getBuilding.data && getDraftBuilding.data) {
      return <Loading />;
    }

    return (
      <div className="SelectBuilding layout-box-page">
        {loading ? <Loading /> : null}
        <div className="tab">
          <div className={`tab-item ${this.state.activeTab === 'building' ? 'active' : ''}`}
            onClick={() => this.setState({ 'activeTab': 'building' })}>
            <div className="icon icon-building" />
            <div className="tab-text">
              Building
            </div>
          </div>
          <div className={`tab-item ${this.state.activeTab === 'building-draft' ? 'active' : ''}`}
            onClick={() => this.setState({ 'activeTab': 'building-draft' })}>
            <div className="icon icon-draft" />
            <div className="tab-text">
              Draft building
            </div>
          </div>
        </div>
        <div className="body">
          {
            this.state.activeTab === 'building' ? this.handleBuildingSection() : this.handleDraftBuildingSection()
          }
        </div>
      </div>
    );
  }
}

SelectBuilding.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'getBuilding': PropTypes.shape({
    'status': PropTypes.number,
    'data': PropTypes.array,
  }),
  'getProfile': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'building': PropTypes.shape({}),
    }),
  }),
  'getDraftBuilding' : PropTypes.shape({
    'data' : PropTypes.shape({}),
  }),
};

const mapStateToProps = ({ getBuilding, getProfile, getDraftBuilding }) => ({ getBuilding, getProfile, getDraftBuilding });

export default connect(mapStateToProps)(SelectBuilding);
